<template>
  <div class="signup-select-page page">
    <el-row
      :gutter="0"
      class="m-0"
    >
      <!--top-navigation></!--top-navigation-->
      <el-col
        :span="24"
        class="article-featured px-0"
      >
        <div class>
          <div class="signup-select-page__header small-header">
            <div class="header__content__bg"></div>
            <div class="header__image__bg signup-select-bg"></div>
            <div class="header__content container">
              <el-row>
                <el-col
                  :md="24"
                  :lg="12"
                >
                  <div class="header__content__wrapper">
                    <h1
                      id="main-content"
                      class="header__title"
                    >
                      Ready to join our community?
                    </h1>
                    <h2 class="header__content-info mb-5">
                      Every member of our diverse, passionate community is driven by the same sense of purpose and ambition. They champion Doncaster and are invested in our Town's culture and growth. And don't forget - it's free to join this great community.
                    </h2>
               
                    <router-link
                      class="already-member"
                      to="/login"
                    >
                      <span>Already a member?</span>
                    </router-link>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="signup-select-page__body">
      <div class="container">
        <el-row>
          <el-col
            :md="24"
            :lg="12"
          >
            <div class="signup-select-card">
              <div class="signup-select-card__content">
                <div class="signup-type-icon-wrapper">
                  <svg-individual-icon />
                </div>

                <span class="se-heading-m signup-select-card__title">Register as an individual
                </span>

                <p class="se-body-s-screen">
                  Are you looking to be part of the conversation with Voluntary organisations of Doncaster? Looking for help, support, advice or networking opportunities?
                </p>
                <p class="se-body-s-screen mb-2 w-100">
                  Use this registration if you:
                </p>
                <ul class="se-body-s-screen pl-3">
                  <li class="mt-4">
                    Want your own personal account on Community Wealth Builder network
                  </li>
                  <li class="mt-4">
                    Want to create your own profile and communicate as yourself when interacting with other members
                  </li>
                  <li class="mt-4">
                    Are a consultant or expert in a particular area and feel you can help Doncaster Community Organisations
                  </li>
                </ul>
                <router-link
                  class="signup-select-btn el-button el-button--primary"
                  to="/sign-up-ngs"
                >
                  <span>Register as an individual</span>
                </router-link>
              </div>
            </div>
          </el-col>

          <el-col
            :md="24"
            :lg="12"
          >
            <div class="signup-select-card">
              <div class="signup-select-card__content pb-3">
                <div class="signup-type-icon-wrapper">
                  <svg-organisation-icon />
                </div>

                <span class="se-heading-m signup-select-card__title">Register as an organisation</span>

                <p class="se-body-s-screen mb-4">
                  Do you have skills or expertise that can support Community organisations of Doncaster?
                </p>
                <p class="se-body-s-screen mb-2 w-100">
                  Use this registration if you want:
                </p>
                <ul class="se-body-s-screen pl-3">
                  <li class="mt-3">
                    To provide support services to organisations and receive requests for help from other members
                  </li>
                  <li class="mt-3">
                    Are willing to provide advice and support free of charge via the network to helping Doncaster organisations support the local residents
                  </li>
                </ul>
                <p class="se-body-s-screen signup-select-gs-readmore mt-4">
                  If you believe you have the Services and connections to help shape Doncaster's future,
                  <a
                    :href="becomingCommunityWealthBuilderUrl"
                    target="_blank"
                  >
                    read more about becoming a Community Wealth Builder.
                  </a>
                </p>

                <router-link
                  class="signup-select-btn el-button el-button--primary"
                  to="/sign-up-gs"
                >
                  <span>Register as an organisation</span>
                </router-link>
                <br />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
//import TopNavigation from "../../layout/top-navigation";
import {SvgIndividualIcon, SvgOrganisationIcon} from "@/components/assets";
export default {
  name: "SignupSelect",
  metaInfo: {
    title: "Join the CWB network",
    meta: [
      {
        name: "description",
        content:
          "Are you a Scottish business looking for support or a business leader happy to offer your expertise? Join the CWB network today."
      }
    ]
  },
  components: {
    //TopNavigation,
    SvgIndividualIcon,
    SvgOrganisationIcon
  },
  computed:{
    becomingCommunityWealthBuilderUrl(){
      return `${process.env.VUE_APP_BE_WELL_CMS_URL}/for-my-organisation/becoming-a-member`
    }
  }
};
</script>

<style>
.festive-delay-text {
  font-size: 22px;
  margin-bottom: 25px;
  margin-left: 10px;
  font-style: italic;
  font-weight: 600;
  color: #bf3a27;
}

.join-home-btn {
  margin: 35px 0px 30px 0px;
}
</style>
